import { ReactElement } from 'react'
import { Body, Caption, Card, IconBox, Label, Value } from './styles'

interface KpiCardProps {
  icon?: string
  label: string
  value: string
  caption?: string
  tone?: 'default' | 'positive'
  compact?: boolean
}

export function KpiCard({ icon, label, value, caption, tone = 'default', compact = false }: KpiCardProps): ReactElement {
  return (
    <Card>
      {icon !== undefined && (
        <IconBox>
          <img src={icon} alt="" width={24} height={24} />
        </IconBox>
      )}
      <Body>
        <Label>{label}</Label>
        <Value $tone={tone} $compact={compact} title={value}>
          {value}
        </Value>
        {caption && <Caption>{caption}</Caption>}
      </Body>
    </Card>
  )
}
